import React from "react";
import { ImageIcon } from "lucide-react";
import { PresignedImageWithPlaceholder } from "@/components/common/PresignedImageWithPlaceholder";
import { formatServiceRevenue, SERVICES_PROGRESS_COLOR } from "./constants";
import type { TopServiceRow } from "./mockData";

export function RateBadge({ rate }: { rate: number }) {
  return (
    <span className="inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full border border-[#E5E5E5] bg-white px-1 text-xs leading-none font-medium text-[#171717]">
      {rate}
    </span>
  );
}

export function ServiceThumbnail({ row }: { row: TopServiceRow }) {
  const [hasError, setHasError] = React.useState(false);

  const placeholder = (
    <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-[#E5E5E5] bg-[#FAFAFA] text-[#A3A3A3]">
      <ImageIcon className="size-4" strokeWidth={1.5} />
    </span>
  );

  if (row.photoId && !hasError) {
    return (
      <PresignedImageWithPlaceholder
        photo={row.photoId}
        placeholder={placeholder}
        alt=""
        className="size-10 shrink-0 rounded-lg object-cover"
      />
    );
  }

  if (!row.imageUrl || hasError) {
    return placeholder;
  }

  return (
    <img
      src={row.imageUrl}
      alt=""
      className="size-10 shrink-0 rounded-lg object-cover"
      onError={() => setHasError(true)}
    />
  );
}

export function ServiceNameCellContent({ row }: { row: TopServiceRow }) {
  return (
    <div className="mx-auto flex w-full max-w-[120px] flex-col items-center justify-center gap-0.5">
      <ServiceThumbnail row={row} />
      <span className="line-clamp-2 w-full min-w-0 text-center text-[10px] leading-none font-normal text-[#0A0A0A]">
        {row.name}
      </span>
    </div>
  );
}

export function GuestsUsedCell({ percent }: { percent: number }) {
  return (
    <div className="mx-auto flex w-full max-w-[140px] items-center justify-center gap-3">
      <div className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-[#F4F4F5]">
        <div
          className="h-full rounded-full"
          style={{
            width: `${percent}%`,
            backgroundColor: SERVICES_PROGRESS_COLOR,
          }}
        />
      </div>
      <span className="w-9 shrink-0 text-center text-sm text-[#171717]">
        {percent}%
      </span>
    </div>
  );
}

export function RevenueCell({ revenue }: { revenue: number }) {
  return (
    <span className="text-[10px] leading-none font-normal text-green-600">
      {formatServiceRevenue(revenue)}
    </span>
  );
}
